import classNames from 'classnames';
import React from 'react';

export default function CloseIcon({ classNames={classNames}, fill = '#1E2E58', stroke="white" }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames}
    >
      <path
        d="M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26802 0 0 6.26801 0 14C0 21.732 6.26802 28 14 28Z"
        fill={fill}
      />
      <path
        d="M9.42773 9.71484L18.5706 18.8577"
        stroke={stroke}
        strokeWidth="2"
      />
      <path
        d="M18.5703 9.71484L9.42745 18.8577"
        stroke={stroke}
        strokeWidth="2"
      />
    </svg>
  );
}
